import { render } from "./AdminUserChat.vue?vue&type=template&id=0f475f94"
import script from "./AdminUserChat.vue?vue&type=script&lang=js"
export * from "./AdminUserChat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__